import axiosInstance, { API_ROUTES } from '../lib/http/httpRequest';
import { AxiosResponse } from 'axios';
import { StorageEntry } from '@/state/storage/storageTypes';

export interface StorageEntityPayload extends Omit<StorageEntry, 'id'> {}

export const getAllStorage = (): Promise<AxiosResponse<StorageEntry[]>> =>
    axiosInstance.get(API_ROUTES.STORAGE);

export const addNewStorageEntry = (
    payload: StorageEntityPayload,
): Promise<AxiosResponse<StorageEntry>> => axiosInstance.post(API_ROUTES.STORAGE, payload);

export const updateStorageEntry = ({
    id,
    ...rest
}: StorageEntityPayload & { id: number }): Promise<AxiosResponse<StorageEntry>> =>
    axiosInstance.put(`${API_ROUTES.STORAGE}/${id}`, rest);
export const deleteStorageEntry = (id: number): Promise<AxiosResponse<void>> =>
    axiosInstance.delete(`${API_ROUTES.STORAGE}/${id}`);

export const getAssetsApi = (): Promise<AxiosResponse<{ assets: string[] }>> =>
    axiosInstance.get(API_ROUTES.ASSETS);
